import $ from 'jquery';

// Global needed for old version of Bootstrap 2.x.
window.jQuery = window.$ = $;
